/**
 * Mapeo de rutas y sus títulos correspondientes
 * Soporta rutas con parámetros usando la sintaxis de react-router
 */
export const ROUTE_TITLES = {
  '/': 'inicio SAT CFT Maule',
  '/estudiante': 'registro estudiantes',
  '/caracterizacion/:matricula': 'caracterizacion',
} as const;

/**
 * Mapeo específico para los centros de estudio
 * tambien soporta rutas dinamicas
 */
export const CENTER_TITLES = {
  li: 'Sede Linares',
  pa: 'Campus Parral',
  // otros centros
} as const;

export type RoutePattern = keyof typeof ROUTE_TITLES;
export type CenterPattern = keyof typeof CENTER_TITLES;
